export class ScoringSystem {
  private score: number = 0;
  private kills: number = 0;
  private startTime: number = 0;
  private bonusScore: number = 0;

  start(): void {
    this.score = 0;
    this.kills = 0;
    this.startTime = Date.now();
    this.bonusScore = 0;
  }

  addKill(): void {
    this.kills++;
  }

  addKills(count: number): void {
    this.kills += count;
  }

  addPatternBonus(difficulty: string): void {
    const bonuses = { EASY: 50, MEDIUM: 100, HARD: 200 };
    this.score += bonuses[difficulty as keyof typeof bonuses] || 50;
  }

  /**
   * Add a level-up bonus to the score
   */
  addLevelUpBonus(bonus: number): void {
    this.bonusScore += bonus;
  }

  getScore(): number {
    return this.score;
  }

  getKills(): number {
    return this.kills;
  }

  getTimeAlive(): number {
    return Date.now() - this.startTime;
  }

  /**
   * Get the total bonus score from level-ups
   */
  getBonusScore(): number {
    return this.bonusScore;
  }
}
